import { z } from 'zod'

import { nanoidSchema, scalarSet, slugSchema, unixTimestamp } from '@/utility'
import { nanoid } from 'nanoid'
import { randomAccessGroupSlug } from '@scalar-org/random-slug'

/** Adapted from Zod email regex - https://github.com/colinhacks/zod/blob/main/src/types.ts */
export const emailDomainRegex =
  /^([A-Za-z0-9]+(-[A-Za-z0-9]+)*\.)+[A-Za-z]{2,}$/i

/** Email domain validation with refine */
export const emailDomainSchema = z
  .string()
  .regex(emailDomainRegex, 'Invalid domain')
  // FQDN max length
  .max(253)

export const accessGroupEmails = scalarSet(
  z
    .set(z.string().email())
    // Can be increased but setting a reasonable amount
    .max(1000, 'You can only add up to 1000 emails'),
).default([])

export const accessGroupDomains = scalarSet(
  z
    .set(emailDomainSchema)
    // Can be increased but setting a reasonable amount
    .max(1000, 'You can only add up to 1000 domains'),
).default([])

/** Access Groups Schema */
export const accessGroupSchema = z.object({
  uid: nanoidSchema.default(nanoid),
  name: z.string().max(40).default(''),
  slug: slugSchema.default(randomAccessGroupSlug),
  /** Set of allowed external email addresses */
  allowedEmails: accessGroupEmails,
  /** List of allowed email domains */
  allowedDomains: accessGroupDomains,
  createdAt: z.number().default(unixTimestamp),
  updatedAt: z.number().default(unixTimestamp),
})

export type AccessGroup = z.infer<typeof accessGroupSchema>
